import { AuthorizeParameters } from "../types/authParameters";

import getAuthQueryParamData from "./getAuthQueryParamData";
import selectParams from "./selectParams";

const defaultAuthParams: AuthorizeParameters = {
  clientId: "",
  redirectUri: "",
  responseType: "code",
  responseMode: "query",
  scope: "openid",
  state: "",
};

const getAuthorizeParams = (): AuthorizeParameters => {
  const allParams = getAuthQueryParamData();

  return {
    ...defaultAuthParams,
    ...selectParams(allParams, [
      "clientId",
      "redirectUri",
      "state",
      "responseMode",
      "responseType",
      "scope",
    ]),
  };
};

export default getAuthorizeParams;
